import { tw } from "@sveabank/cc-common";
import type React from "react";

type Breakpoint = "tablet" | "laptop" | "desktop";

type Props = {
	children: React.ReactNode;
	display?: "block" | "flex" | "inline";
} & ({ from: Breakpoint; to?: never } | { to: Breakpoint; from?: never }); // prettier-ignore

const Hide = ({ from, to, display = "block", children }: Props) => {
	const classes = from ? tw(display, `${from}:hidden`) : tw("hidden", `${to}:${display}`);

	return <div className={classes}>{children}</div>;
};

export default Hide;
